import { mergeStyles } from '@bulknutrients/bulk-shared-lib/utils';
import { useCustomer } from '@hooks/customer/useCustomer';
import Link from 'next/link';
import type { ReactElement, ReactNode } from 'react';

export function TextLink({
  children,
  href,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
  href: string;
} & Record<string, unknown>): ReactElement {
  if (href === '/rewards') {
    return <RewardsLink {...props}>{children}</RewardsLink>;
  }

  if (href.startsWith('/api') || href.startsWith('/addtocart')) {
    // If the link is an API endpoint, we don't want to use the Link component
    // as it will prefetch on hover. Instead, we use a regular anchor tag.
    return (
      <a
        href={href}
        className={mergeStyles(className ?? '', 'clickable')}
        data-umami-event="hue-link-click"
        data-umami-event-slug={href}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
      href={href}
      className={mergeStyles(className ?? '', 'clickable')}
      data-umami-event="hue-link-click"
      data-umami-event-slug={href}
      {...props}
    >
      {children}
    </Link>
  );
}

export function RewardsLink({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
} & Record<string, unknown>): ReactElement {
  const { customer } = useCustomer();

  return (
    <a
      className={mergeStyles(className ?? '', 'clickable')}
      href={customer ? '/account/rewards' : '/rewards'}
      data-umami-event="hue-link-click"
      data-umami-event-slug={customer ? '/account/rewards' : '/rewards'}
      {...props}
    >
      {children}
    </a>
  );
}
